import { Cancellation, PaymentStatus } from 'api/common/constants'
import { PositionResponse } from 'api/common/responses'
import { positionSelectAPI, positionsAPI } from 'api/position'
import Footer from 'components/Footer'
import Header from 'components/Header'
import * as React from 'react'
import { Button, Form, Spinner } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import loginData from 'utilities/loginData'
import InputSelectField from 'components/InputSelectField'
import { KeyValue } from 'utilities/resources/options'

const SceneComponent: React.FC = () => {
  const navigate = useNavigate()
  const [selectablePositions, setSelectablePositions] = React.useState<KeyValue[]>([])
  const [selectedPositionCount, setSelectedPositionCount] = React.useState<string>('1')
  const [buttonEnabled, setButtonEnabled] = React.useState(false)
  const [committed, setCommitted] = React.useState(false)

  /**
   * 「登録する」ボタン
   */
  const handleRegister = () => {
    setCommitted(true)
    const positionCount = Number(selectedPositionCount)
    positionSelectAPI({ positionCount }, (result: boolean) => {
      if (result) {
        loginData.setPositionContractSelectedData({ additionPositionCount: positionCount })
        navigate(loginData.getPositionSelectNextScene())
      } else {
        setCommitted(false)
      }
    })
  }

  React.useEffect(() => {
    if (!loginData.isLoggedIn()) {
      navigate('/')
    } else if (loginData.isCampaignAwaitingFullRegistration()) {
      // キャンペーン仮登録のみ完了で住所・口座情報未入力のユーザーはマイページに戻す
      navigate('/myPage', { replace: true })
    } else {
      positionsAPI((response: PositionResponse) => {
        // 使用済み枠 = 入金済み+契約中+名義変更なし のポジションのみ
        // 解約/クーリングオフ/名義変更のポジションは枠を消費しない → 新規購入可能
        const registeredCount = response.positions.reduce(
          (count, position) =>
            count +
            (position.paymentStatus === PaymentStatus.Paid &&
            position.cancellationType === Cancellation.Contract &&
            !position.isChangedAssignment
              ? 1
              : 0),
          0,
        )
        // 修正: maxPositionCountを固定で使用（重複position_numberの影響を受けない）
        const registerableCount = response.maxPositionCount - registeredCount
        const selectablePositions: KeyValue[] = []
        for (let i = 0; i < registerableCount; i++) {
          selectablePositions.push({
            key: `${i + 1}`,
            value: `${i + 1}`,
          })
        }
        setSelectablePositions(selectablePositions)
        setButtonEnabled(registerableCount > 0)
      })
    }
  }, [navigate])

  return (
    <>
      <Header title="ポジション数選択" />
      <main>
        <section className="mx-4 my-5">
          <div>
            <p>申込みを希望するポジション数を選択ください。</p>
            <p>2ポジション目以降は後ほど登録することも可能です。</p>
          </div>
          <Form className="mt-5">
            <InputSelectField name="position" label="ポジション数" items={selectablePositions} bold setValue={setSelectedPositionCount} />
            <div className="mt-5">
              <Button variant="primary" className="w-100 py-4" onClick={handleRegister} disabled={!(buttonEnabled && !committed)}>
                <Spinner className="me-2" as="span" animation="border" size="sm" role="status" aria-hidden="true" hidden={!committed} />
                登録する
              </Button>
            </div>
          </Form>
        </section>
      </main>
      <Footer className="mt-5" />
    </>
  )
}

export default SceneComponent
